import { API_INSTANCE, buildURLWithState } from 'src/features/utils';
import { Attendee } from 'src/types/types';
import { UpdateAttendeeModel } from 'src/redesign/features/AttendeesSidebar/types';

export async function fetchAttendeeApi(state, id: Attendee['id']) {
  return await API_INSTANCE.get<Attendee>(
    buildURLWithState(state, `/api/v1/dashboard/attendees/${id}`),
  );
}

export async function updateAttendeeDataApi(state, id: Attendee['id'], data: UpdateAttendeeModel) {
  return await API_INSTANCE.put<unknown>(
    buildURLWithState(state, `/api/v1/dashboard/attendees/${id}`),
    data,
  );
}
export async function deleteAttendeeApi(state, id: Attendee['id']) {
  return await API_INSTANCE.delete<unknown>(`/api/v1/dashboard/attendees/${id}`);
}
